<div class="clear"></div>
<div [ngClass]="isWidgetView ? 'banner-img' : 'hide-me-d'">
  <div class="banner-text">
    <h3>Legal</h3>
    <p>Access your insurance documentation from one convinient location.</p>
  </div>
</div>
@if (edeliveryData) {
  <div [ngClass]="isWidgetView ? 'widget-container' : ''">
    <h3 class="group-title" id="padding-setter">
      {{edeliveryData.sectionTitle}}
    </h3>
    @if (edeliveryData.content) {
      <div class="e-delivery borderless">
        <div id="font-changer">
          @for (item of edeliveryData.content; track item) {
            <div>
              @if ((item.displayType === 'header')) {
                <div>
                  <p class="section-header">{{item.text}}</p>
                </div>
              }
              @if ((item.displayType === 'string') && (item.title === '')) {
                <div>
                  <p>{{item.text}}</p>
                </div>
              }
              @if ((item.displayType === 'string') && (item.title !== '')) {
                <div>
                  @if (item.header && (item.header !== null) && (item.header !== undefined) && (item.header !== '')) {
                    <p class="header">{{item.header}}</p>
                  }
                  <p class="title">{{item.title}}</p>
                  <p>{{item.text}}</p>
                </div>
              }
              @if ((item.displayType === 'list')) {
                <div>
                  <div class="e-delivery-list-items">
                    <ul>
                      @for (content of item.listItems; track content) {
                        <div>
                          <li>{{content.text}}</li>
                        </div>
                      }
                    </ul>
                  </div>
                  <br />
                </div>
              }
              @if ((item.displayType === 'table')) {
                <div>
                  <table>
                    <tbody>
                      @for (el of item.listItems; track el) {
                        <tr class="row">
                          <td class="c1">{{ el.id }}</td>
                          <td class="c2">{{ el.text }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if ((item.displayType === 'phone')) {
                <div>
                  <p>{{item.text}}{{callUsNumber.phoneNumber}}</p>
                </div>
              }
              @if ((item.displayType === 'disclaimer')) {
                <div>
                  <p class="-d">{{item.text}}</p>
                </div>
              }
              @if ((item.displayType === 'link')) {
                <div>
                  <p>
                    <a class="print-link" (click)="printDisclosure()">{{item.text}}</a>
                  </p>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}